module.exports = __webpack_public_path__ + "img/DE06224.e802782a.png";